import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { ArchiveBoxIcon, XMarkIcon } from '@heroicons/react/16/solid'
import { Button, ButtonText } from '../ui/button'
import React, { useState } from 'react'
import useArchiveCategory from '@/services/api/transaction-category/useArchiveCategory'
import useDeleteTransactionCategory from '@/services/api/transaction-category/useDeleteTransactionCategory'

import useGetIsEmptyCategory from '@/services/api/transaction-category/useGetIsEmptyCategory'

export default function ArchiveEmptyCategory({
  category,
}: {
  category: Object
}) {
  const { data: _isEmpty, status: isEmptyStatus } = useGetIsEmptyCategory(
    category.id,
  )

  const isEmpty = _isEmpty?.is_empty

  const { mutate: deleteCategory, status: deleteStatus } =
    useDeleteTransactionCategory(category?.id)
  const { action: archiveCategory, status: archiveStatus } = useArchiveCategory(
    category?.id,
  )

  const handleArchive = (data) => {
    archiveCategory(data)
  }

  const handleDelete = () => {
    deleteCategory()
  }

  const [showConfirmation, setShowConfirmation] = useState(false)

  return (
    <>
      <Button
        variant="destructiveGhost"
        onClick={() => {
          setShowConfirmation(true)
        }}
        className={'w-full justify-start'}
      >
        <ArchiveBoxIcon />
        <ButtonText>Archive</ButtonText>
      </Button>

      <Dialog open={showConfirmation} onOpenChange={setShowConfirmation} modal>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="leading-relaxed">
              Archive or Delete{' '}
              {category.direction === 1 ? 'Money In' : 'Money Out'} Category -{' '}
              {category.name}?
            </DialogTitle>
            <DialogClose>
              <XMarkIcon />
            </DialogClose>
          </DialogHeader>

          <DialogBody>
            {isEmptyStatus === 'pending' ? (
              'Checking....'
            ) : (
              <>
                {isEmpty ? (
                  <>
                    <p>
                      The selected category has no transactions. You can choose
                      to either archive it or permanently delete it. Please
                      select one of the following options:
                    </p>
                    <ul className="list-inside list-disc pl-4">
                      <li>
                        Archive Category: This will move the category to the
                        Archive folder. It won't be available for use but can be
                        restored later.
                      </li>

                      <li>
                        Delete Category: This will permanently remove the
                        category and all its associated data.
                      </li>
                    </ul>
                  </>
                ) : (
                  <>
                    <p>
                      Archiving this{' '}
                      {category.direction === 1 ? 'Money In' : 'Money Out'}{' '}
                      category will delete all scheduled transactions associated
                      with it. Are you sure you want to proceed?
                    </p>
                  </>
                )}
              </>
            )}
          </DialogBody>

          {isEmptyStatus === 'success' && (
            <>
              {isEmpty ? (
                <DialogFooter>
                  <DialogClose asChild>
                    <Button
                      onClick={handleArchive}
                      type="button"
                      variant="secondary"
                      loading={archiveStatus.status === 'pending'}
                    >
                      <ButtonText>Archive</ButtonText>
                    </Button>
                  </DialogClose>

                  <Button
                    type="button"
                    variant="destructive"
                    onClick={handleDelete}
                    loading={deleteStatus === 'pending'}
                  >
                    <ButtonText>Delete</ButtonText>
                  </Button>
                </DialogFooter>
              ) : (
                <DialogFooter>
                  {/* <DialogClose asChild> */}
                  <Button
                    onClick={handleArchive}
                    type="button"
                    variant="destructive"
                    loading={archiveStatus.status === 'pending'}
                  >
                    <ButtonText>Archive</ButtonText>
                  </Button>
                  {/* </DialogClose> */}

                  <DialogClose asChild>
                    <Button type="button" variant="secondary">
                      Cancel
                    </Button>
                  </DialogClose>
                </DialogFooter>
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}
